import { ref } from "vue";
import { defineStore } from "pinia";
import {
  type ChangelogDto,
  getApiV1Changelogs,
  postApiV1ChangelogsRead,
} from "@/client";

export const useChangelogsStore = defineStore("changelogs", () => {
  const changelogs = ref<ChangelogDto[]>([]);
  const changelogsLoading = ref(false);
  const changelogsLoaded = ref(false);

  async function fetchChangelogs() {
    changelogsLoading.value = true;
    try {
      const response = await getApiV1Changelogs({
        query: { "only-new": true },
      });
      if (response.error) {
        console.error("Error fetching changelogs:", response.error);
        return;
      }
      changelogs.value = response.data!;
      changelogsLoaded.value = true;
    } finally {
      changelogsLoading.value = false;
    }
  }

  async function ensureChangelogsLoaded() {
    if (!changelogsLoaded.value) {
      await fetchChangelogs();
      console.log("Changelogs loaded", changelogs.value);
    }
  }

  async function markAsRead() {
    const response = await postApiV1ChangelogsRead({
      body: {
        changelogIds: changelogs.value.map((c) => c.id!),
      },
    });
    if (response.error) {
      throw new Error("Failed to mark changelogs as read: " + response.error);
    }
  }

  //#endregion

  return {
    ensureChangelogsLoaded,
    markAsRead,
    changelogs,
    changelogsLoaded,
    changelogsLoading,
  };
});
